import {
  User,
  VoucherApproval,
  VoucherType,
} from '../types'

export function getFileExtension(filename: string): string | null {
  const parts = filename.split('.')
  return parts.length > 1 ? parts.pop() ?? null : null
}

export function getLatestApprovingUser(voucher: VoucherType): User | null {
  if (!voucher.voucher_approvals || voucher.voucher_approvals.length === 0) {
    return null
  }

  const latestApproval = voucher.voucher_approvals
    .filter((a) => a.approved_at !== null && a.status === 'APPROVED')
    .sort((a, b) => b.order_number - a.order_number)[0]

  return latestApproval?.approver ?? null
}

export function getMyApproval(
  voucher: VoucherType,
  userId: string
): VoucherApproval | null {
  const approval = voucher.voucher_approvals.find(
    (va) => va.approver.id === userId
  )
  return approval || null
}

export function isRoleAmin(role: string): boolean {
  return role === 'AMIN' || role === 'LOCAL_AMIN'
}

export function isRoleAllowedPayments(roleId: number): boolean {
  return roleId === 2 || roleId === 3 || roleId === 5
}

export function convertToIsoString(date: number): string {
  return new Date(date * 1).toISOString().split('T')[0]
}

export const formatPaymentDate = (dateVal?: string | number | null) => {
  if (!dateVal) return ''
  const d = new Date(
    typeof dateVal === 'string' && /^\d+$/.test(dateVal)
      ? Number(dateVal)
      : dateVal
  )
  return !isNaN(d.getTime()) ? d.toISOString().split('T')[0] : ''
}

export const REPORTS_ALLOWED_DEPARTMENTS: ReadonlyArray<string> = [
  'amin',
  'maal',
  'muhasib',
  'internal auditor',
  'amir',
  'sadr',
  'gen.sec',
]

export function hasReportsAccess(departmentName: string): boolean {
  return REPORTS_ALLOWED_DEPARTMENTS.includes(departmentName.toLowerCase())

}

export const getExpenseMonthOptions = () => {
  const today = new Date()
  const currentMonth = today.getMonth()
  const currentYear = today.getFullYear()
  const options: Array<{ key: number; value: string }> = []

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]

  const getMonthData = (d: Date) => {
    const year = d.getFullYear()
    const month = d.getMonth()
    const key = parseInt(`${year}${month + 1 < 10 ? '0' : ''}${month + 1}`)
    const value = monthNames[month]
    return { key, value }
  }

  if (currentMonth !== 6) {
    options.push(getMonthData(new Date(currentYear, currentMonth - 1, 1)))
  }

  options.push(getMonthData(new Date(currentYear, currentMonth, 1)))

  if (currentMonth !== 5) {
    options.push(getMonthData(new Date(currentYear, currentMonth + 1, 1)))
  }

  return options
}

export const formatPeriod = (period: number | null | undefined) => {
  if (!period) return ''
  const year = Math.floor(period / 100)
  const month = period % 100

  const monthName = new Date(0, month - 1).toLocaleString('en-US', {
    month: 'short',
  })

  return `${monthName} ${year}`
}
